import React, { useState } from 'react'
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { getDistance } from 'geolib';
import { LazyLoadImage } from "react-lazy-load-image-component";
import './App.css';


////////////////////////////
// Load Data
////////////////////////////
import DATA from "./doctors-list.json"


const App = () => {

  ////////////////////////////
  // Define State
  ////////////////////////////
  
  const [zip, setZip] = useState('');
  const [radius, setRadius] = useState(25);
  // Initialize localities to DATA so it shows all by default
  const [localities, setLocalities] = useState(DATA);
  const [currentPage, setCurrentPage] = useState(0);
  const [pendingFilterTags, setPendingFilterTags] = useState([]);

  ////////////////////////////
  // SHOW ALL
  ////////////////////////////

  const resetSearch = () => {
    setPendingFilterTags([]);
    setZip('');
    setLocalities(DATA);
    setCurrentPage(0);
    setRadius(10)
    // Reset form elements here if necessary.
  };

  const showAll = (e) => {
    e.preventDefault()
    resetSearch()
  }


  ////////////////////////////
  // Handle Checkbox
  ////////////////////////////

  const handleCheck = (e) => {
    const tagValue = e.target.value;
    setPendingFilterTags(e.target.checked
      ? [...pendingFilterTags, tagValue]
      : pendingFilterTags.filter(tag => tag !== tagValue));
  };

  const handleSubmitClick = () => {
    let filteredLocalitiesByTags = DATA;

    // Apply the tag filters.
    if (pendingFilterTags.length > 0) {
      filteredLocalitiesByTags = DATA.filter(node =>
        pendingFilterTags.every(filterTag =>
          node.tags.map(tag => tag.slug).includes(filterTag)
        )
      );
    }

    // Now decide if we need to perform a geocode search.
    if (zip) {
      getGeocodeData(zip, filteredLocalitiesByTags); // Updated function signature.
    } else {
      // No ZIP code provided, simply apply the tag filter results.
      setLocalities(filteredLocalitiesByTags);
    }
  };

  const getGeocodeData = (zipcode, dataToFilter) => {
    axios.get(`https://api.zippopotam.us/us/${zipcode}`)
      .then(response => {
        const location = response.data.places[0];
        var filteredLocalities = dataToFilter.filter(dataEntry => { // Initialize with dataToFilter instead of undefined
          const distanceMiles = getDistance(
            { latitude: parseFloat(location.latitude), longitude: parseFloat(location.longitude) },
            { latitude: dataEntry.lat, longitude: dataEntry.long }
          ) / 1609.344; // Convert meters to miles
          return distanceMiles <= radius; // Ensure 'radius' is accessible in this scope, e.g., passed as an argument or part of the component state
        });
    
        // Map and add distance information
        filteredLocalities = filteredLocalities.map(dataEntry => {
          const distanceMiles = getDistance(
            { latitude: parseFloat(location.latitude), longitude: parseFloat(location.longitude) },
            { latitude: dataEntry.lat, longitude: dataEntry.long }
          ) / 1609.344; // Convert meters to miles
          return { ...dataEntry, distance: distanceMiles };
        });
    
        // Sort localities by distance
        filteredLocalities.sort((a, b) => a.distance - b.distance);
    
        // Add formatted distance info for display
        filteredLocalities = filteredLocalities.map(dataEntry => ({
          ...dataEntry,
          distanceInfo: `${dataEntry.distance.toFixed(2)} miles away`
        }));
        setLocalities(filteredLocalities);
      })
      .catch(error => {
        console.error('Geocoding error:', error);
      });
  };

  ////////////////////////////
  // Handle Search
  ////////////////////////////

  const handleZipChange = (e) => {
    setZip(e.target.value);
  };

  const handleRadiusChange = (e) => {
    setRadius(e.target.value);
  };


  ////////////////////////////
  // Handle Pagination
  ////////////////////////////

  const windowSize = window.innerWidth;

  if(windowSize < 768) {
    var PER_PAGE = 4;
  } else {
    PER_PAGE = 10;
  }

  var pageCount = Math.ceil(localities.length / PER_PAGE);
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
    document.getElementById("TopOfList").scrollIntoView();
  }
  const offset = currentPage * PER_PAGE;

    
  ////////////////////////////
  // Render App
  ////////////////////////////

  return (
    <div className='container jump-to-target' id='TopOfList'>
      <div className='filter-bar'>
        <div className='filter-bar-header'>
          <p>Find the best mesothelioma doctors closest to your location which specialize on your exact diagnosis.</p>
        </div>
        <div className='doctors-search-container'>
          <input id="search" type="text" placeholder="Search by Zip Code" value={zip} onChange={handleZipChange} />
          <img className="search-icon" src="https://media-mesotheliomaguide-com.s3.amazonaws.com/images/CancerCenters/search.svg" alt="Search Icon" />
          <div>
          <select id="radius" className="radius-dropdown" value={radius} onChange={handleRadiusChange}>
              <option value="25">25 miles</option>
              <option value="50">50 miles</option>
              <option value="100">100 miles</option>
              <option value="150">150 miles</option>
              <option value="250">250 miles</option>
              <option value="500">500 miles</option>
            </select>
          </div>
        </div>
        <div className="filters-container">
          <div className="filters font-link">
            <p>Mesothelioma Specialty:</p>
            <ul>
              <li>
                <input 
                  type="checkbox"  
                  id="pleural"
                  value="pleural"
                  onChange={handleCheck}
                  checked={pendingFilterTags.includes('pleural')}
                />
                <label htmlFor="Pleural">Pleural Mesothelioma</label>
              </li>
              <li>
                <input 
                  type="checkbox" 
                  id="peritoneal"
                  value="peritoneal"
                  onChange={handleCheck}
                  checked={pendingFilterTags.includes('peritoneal')}
                />
                <label htmlFor="Peritoneal">Peritoneal Mesothelioma</label>
              </li>
            </ul>
          </div>
        </div>
        <div className='centers-submit-button'>
            <input type='submit' value='Find a Doctor Near You' onClick={handleSubmitClick} />
            <a href='#' onClick={showAll}>Show All</a>
        </div>
      </div>
      <div className='results-container'>
        <div className="centers-flex">
        {localities.length === 0 && zip ? (
            <div className='no-matching-text'>
                <p>Sorry, No Mesothelioma Doctors Were Found in: <span style={{marginLeft:'10px'}}>" {zip} "</span>.</p>
                <p><a style={{textDecoration:'underline'}} href='mailto:information@mesotheliomaguide.com'>Send us a message</a>, we can help you find a mesothelioma doctor near you.</p>
                <p>To return to the full list click: <span style={{marginLeft:'10px'}}>" <a href='#' onClick={showAll} style={{textDecoration:'underline'}}>Show All/Reset</a> "</span>.</p>
                
            </div>
          ) : (
            localities.slice(offset, offset + PER_PAGE).filter((item) => {
                pageCount = Math.ceil(localities.length / PER_PAGE);
                return item
              }).map((item) => {
                  return (
                      <div className='center-result-item' key={item.id}>
                          <div className="distance-info">
                            <p>{item.distanceInfo}</p>
                          </div>
                          <div className='centers-results-header'>
                              <a href={item.link} target="_blank" rel="noreferrer">
                                <LazyLoadImage
                                  src={item.image}
                                  alt={item.title}
                                  width={130}
                                  height={130}
                                  placeholdersrc="https://wpmedia.mesotheliomaguide.com/wp-content/uploads/2023/02/22175048/doctors-placeholder.webp"
                                />
                              </a>
                              <div className='half-circle'></div>
                              <p><a href={item.link} target="_blank" rel="noreferrer">{item.title}</a></p>
                          </div>
                          <div className="doctors-tooltip">
                              <span className="tooltiptext">{item.topRanked}</span>
                          </div>
                          <div className='center-info'>
                              <ul>
                                  <li><strong>{item.location}<br/>{item.address}<br/>{item.city}, {item.state} {item.zip}</strong></li>
                                  <li>{item.specialty}</li>
                                  <li>{item.doctorType}</li>
                                  <li>{item.description} <a style={{textDecoration:'underline'}} href={item.link} target="_blank" rel="noreferrer">Read More</a></li>
                              </ul>
                          </div>

                          <a href={item.link} target="_blank" rel="noreferrer">
                              <div className='center-result-button'>
                                  <p>Contact {item.title}</p>
                              </div>
                          </a>
                      </div>
                  )
              })
          )}
        </div>

        <ReactPaginate
          previousLabel={<FontAwesomeIcon icon={solid('chevron-left')} />}
          nextLabel={<FontAwesomeIcon icon={solid('chevron-right')} />}
          containerClassName={'pagination'}
          previousLinkClassName={'paginationLink'}
          nextLinkClassName={'paginationLink'}
          disabledClassName={'paginationDisabled'}
          activeClassName={'paginationActive'}
          pageLinkClassName={"pageLink"}
          activeLinkClassName={"paginationActive"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          onPageChange={handlePageClick}
          forcePage={currentPage}
        />

      </div>
    </div>
  )
}

export default App;